import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';
import { ISoilProfileModel } from '../../util/Request/requestType';

interface IWarningMessage {
    warningMessage: string
}

interface IScuccessMessage {
    successMessage: string
}

interface commonModel {
    downloadList: any[],
    visible:boolean,
    deleteFiled:boolean,
    type:string,
    profileSelectedList: ISoilProfileModel[]
    showLoading?: boolean
    showWarningMessage?: IWarningMessage
    successMessage?: IScuccessMessage,
    currentSys?: 'home' | 'weather' | 'soil' | 'agrialert',
    currentShowDetailKey?: string
    refreshModalShow: boolean
}
const initialState: commonModel = {
    downloadList: [],
    visible:false,
    deleteFiled:false,
    type:'',
    profileSelectedList: [],
    showLoading: false,
    showWarningMessage: {warningMessage: ''},
    successMessage: {successMessage: ''},
    currentSys: 'home',
    currentShowDetailKey: '',
    refreshModalShow: false
};
export const common = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setDownloadFileFunction: (state, action: PayloadAction<commonModel>) => {
            console.log(action.payload.downloadList);
            return {
                ...state,
                downloadList:[...action.payload.downloadList],
                visible:true,
                deleteFiled:state.deleteFiled,
                type:state.type,
            };
        },
        downloadFile: (state, action: PayloadAction<commonModel>) =>{
            // console.log(action.payload);
        },
        closeDownFile:(state, action: PayloadAction<commonModel>) => {
            return {
                ...state,
                downloadList:[...state.downloadList],
                visible:false,
                deleteFiled:state.deleteFiled,
                type:state.type,
            };
        },
        deleteFile:(state, action: PayloadAction<commonModel>) => {
            return {
                ...state,
                downloadList:[],
                visible:state.visible,
                deleteFiled:!state.deleteFiled,
                type:state.type,
            };
        },
        updateProfileSelectedList: (state, action: PayloadAction<ISoilProfileModel[]>) => {
            return {
                ...state,
                profileSelectedList: action.payload,
            };

        },
        updatePanelVisible: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                visible: action.payload
            };
        },
        updateShowLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                showLoading: action.payload
            };
        },
        updateWarningMessage: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                showWarningMessage: { warningMessage: action.payload }
            };
        },
        updateSuccessMessage: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                successMessage: { successMessage: action.payload}
            };
        },
        updateCurrentSys: (state, action: PayloadAction<'home' | 'weather' | 'soil' | 'agrialert'>) => {
            return {
                ...state,
                currentSys: action.payload
            };
        },
        updateCurrentShowDetailKey: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                currentShowDetailKey: action.payload
            };
        },
        updateRefreshModalShow: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                refreshModalShow: action.payload
            };
        }
    }
});

export type {
    commonModel
};

export const {
    updateProfileSelectedList,
    updatePanelVisible,
    updateShowLoading,
    updateWarningMessage,
    updateSuccessMessage,
    updateCurrentSys,
    updateCurrentShowDetailKey,
    updateRefreshModalShow
} = common.actions;
export const commonDataList = (state: RootState) => state.commonData;
export default common.reducer;

